var schoolId
let incremented = {
  "学校情報": false,
  "追加学校情報": false,
  "求人情報": false,
  "説明会・セミナー": false
};

// 並び替え等でページがリロードされた際、URLの tab パラメータから対象タブを復元する。
// app.js のタブ復元はクエリの「先頭パラメータ」をインデックスとして使うため、
// to_query のキー並び順に依存して失敗することがある。ここでは tab を直接参照して確実に復元する。
// app.js（defer）の ready ハンドラより後に実行する必要があるため setTimeout で後段に回す。
$(function() {
  setTimeout(function() {
    const tabParam = new URLSearchParams(window.location.search).get('tab');
    if (tabParam === null) return;

    const index = parseInt(tabParam, 10);
    if (isNaN(index)) return;

    const $tabs = $('.tab');
    const $contents = $('.tab-contents__group');
    if (!$tabs.eq(index).length || !$contents.eq(index).length) return;

    $tabs.removeClass('-tabActive');
    $contents.removeClass('-tabShow');
    $tabs.eq(index).addClass('-tabActive');
    $contents.eq(index).addClass('-tabShow');
  }, 0);
});

$(document).on('change', '.filter-active-events', function() {
  const isChecked = $(this).is(':checked');
  if (isChecked) {
    // チェックボックスがONの場合、受付終了（.ended）を非表示
    $('.ended').hide();
  } else {
    // チェックボックスがOFFの場合、受付終了も含めすべて表示
    $('.ended').show();
  }
});

window.initSchoolPageView = async function(school_id) {
  schoolId = school_id
  const baseKind = (() => {
    const tabParam = new URLSearchParams(window.location.search).get('tab');
    const tab = tabParam ? parseInt(tabParam, 10) : null;

    let kindValue = 0; // デフォルトは "学校情報"

    if (tab !== null) {
      kindValue = tab;
    }

    if (kindValue != 0 && !window.schoolInfoDisplayActive) {
      kindValue += 1; // "追加学校情報" にシフト
    }

    return kindValue;
  })();

  const kind = (() => {
    switch (baseKind) {
      case 0: return '学校情報';
      case 1: return '追加学校情報';
      case 2: return '求人情報';
      case 3: return 'イベント情報';
      default: return null;
    }
  })();

  if (!kind) return;

  incrementPageView(kind);
};

$(document).on("click", ".school-info-tab", function(){
  const kind = $(this).data("kind");
  incrementPageView(kind);
})

function incrementPageView(kind) {
  if (!incremented[kind]) {
    // 現在のパスから te/sc を判定してエンドポイントを決定
    const basePath = window.location.pathname.startsWith('/te/') ? '/te/schools/' : '/sc/schools/';
    $.ajax({
      url: basePath + schoolId + "/increment_page_views",
      type: "POST",
      data: { kind: kind },
      headers: {
        "X-CSRF-Token": $('meta[name="csrf-token"]').attr("content")
      },
      success: function(response) {},
      error: function(xhr, status, error) {
      }
    });
  }
  incremented[kind] = true;
}